// extracted by mini-css-extract-plugin
export default {"container":"styles__container--H3n47","visa":"styles__visa--Y+VSE","mc":"styles__mc--uINNf","amex":"styles__amex--veL45","discover":"styles__discover--r3MG1"};